import { defineStore } from "pinia";
import { ref } from "vue";

import { $streemApiV1 } from "shared/boot/api";
import useTeamPicker from "shared/composables/useTeamPicker";
import features from "shared/services/features";
import type { FilterSet } from "shared/types";

export const useFilterSetsStore = defineStore("filterSets", () => {
  const filterSets = ref<FilterSet[]>([]);

  const filterSetsLoaded = ref(false);

  async function getFilterSets(): Promise<void> {
    const { selectedTeamPreference } = useTeamPicker();
    let params = {};

    if (features.has("has_team_workspaces")) {
      params = {
        organisation_team_id: selectedTeamPreference.value,
      };
    }

    const response = await $streemApiV1.get("filter_sets", { params });
    filterSets.value = response.data?.filter_sets || [];
    filterSetsLoaded.value = true;
  }

  function addFilterSet(filterSet: FilterSet): void {
    filterSets.value.push(filterSet);
  }

  function removeFilterSet(filterSetId: number): void {
    filterSets.value = filterSets.value.filter(
      (filterSet) => filterSet.id !== filterSetId
    );
  }

  function updateFilterSet(updatedFilterSet: FilterSet): void {
    filterSets.value = filterSets.value.map((filterSet) =>
      filterSet.id === updatedFilterSet.id ? updatedFilterSet : filterSet
    );
  }

  return {
    addFilterSet,
    filterSets,
    filterSetsLoaded,
    getFilterSets,
    removeFilterSet,
    updateFilterSet,
  };
});

export default useFilterSetsStore;
